import { RENDERABLE_PAGES } from '#src/docs.tsx';

interface SiteTrackingProps {
  currentPage: string;
  siteSection: string;
  siteLanguage: string;
  zone: string;
}

export const getSiteTrackingData = (): SiteTrackingProps => ({
  currentPage: getCurrentPageName(),
  siteSection: getSiteSelection(),
  siteLanguage: 'en',
  zone: 'anz-1',
});

const getSiteSelection = (): string => {
  const pathname = location.pathname;
  const segments = pathname.split('/').filter(Boolean);
  const firstSegment = segments[0] || 'home';
  return firstSegment;
};

const getCurrentPageName = (): string => {
  if (typeof location === 'undefined') {
    return 'Unknown';
  }
  const pathname = location.pathname;
  const currentPage = Object.values(RENDERABLE_PAGES).find(
    (page) => page.path === pathname,
  );
  if (currentPage) {
    return currentPage?.label.toString().replaceAll(' ', '-') || '';
  }

  if (pathname === '/manage') {
    return 'Dashboard';
  }
  const segments = pathname.split('/').filter(Boolean);
  const lastSegment = segments[segments.length - 1];
  return lastSegment.charAt(0).toUpperCase() + lastSegment.slice(1);
};
